import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';

const API_PAGA = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconBack     = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M16 10H4M9 14l-5-4 5-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconKit      = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><rect x="2" y="7" width="20" height="15" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconGame     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><rect x="2" y="6" width="20" height="12" rx="4" stroke="currentColor" strokeWidth="2"/><path d="M7 12h4M9 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="12" r="1.5" fill="currentColor"/></svg>);
const IconStar     = ({ filled }) => (<svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={filled?'#f59e0b':'none'} stroke="#f59e0b" strokeWidth="2" strokeLinejoin="round"/></svg>);
const IconTag      = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="7" cy="7" r="1.5" fill="currentColor"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20" style={{animation:'rd-spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const colorMap = {
  verde:    { bg:'linear-gradient(135deg,#d4f4e8,#82D8B3)', text:'#0f3525' },
  azul:     { bg:'linear-gradient(135deg,#dbeafe,#60a5fa)', text:'#1e3a5f' },
  amarillo: { bg:'linear-gradient(135deg,#fef9c3,#fbbf24)', text:'#713f12' },
  rosa:     { bg:'linear-gradient(135deg,#fce7f3,#f9a8d4)', text:'#831843' },
  morado:   { bg:'linear-gradient(135deg,#ede9fe,#a78bfa)', text:'#3b0764' },
  gris:     { bg:'linear-gradient(135deg,#f3f8f5,#82D8B3)', text:'#0f3525' },
};
const TIPO_ICON  = { recurso:<IconPdf/>, kit:<IconKit/>, juego:<IconGame/> };
const TIPO_LABEL = { recurso:'PDF Imprimible', kit:'Cuadernillo', juego:'Juego terapéutico' };

/* ── Galería de imágenes ── */
function Galeria({ imagenes, imagenPortada, color }) {
  const col = colorMap[color] || colorMap.verde;
  const todasImagenes = [
    ...(imagenPortada ? [{ url: imagenPortada, id: 'portada' }] : []),
    ...(imagenes || []),
  ];
  const [activa, setActiva] = useState(0);

  if (todasImagenes.length === 0) {
    return (
      <div style={{
        width:'100%', aspectRatio:'1/1', borderRadius:20,
        background: col.bg,
        display:'flex', alignItems:'center', justifyContent:'center',
        color: col.text,
      }}>
        <div style={{opacity:.4, transform:'scale(2)'}}>
          {TIPO_ICON['recurso']}
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Imagen principal */}
      <div style={{
        width:'100%', aspectRatio:'1/1', borderRadius:20,
        overflow:'hidden', background:'#f3f8f5',
        position:'relative', marginBottom:'.75rem',
        boxShadow:'0 8px 32px rgba(0,0,0,.1)',
      }}>
      <img
          src={todasImagenes[activa].url}
          alt={`Vista ${activa+1}`}
          style={{width:'100%', height:'100%', objectFit:'contain', background:'#fff'}}
        />
        {todasImagenes.length > 1 && (
          <>
            <button onClick={()=>setActiva(a=>(a-1+todasImagenes.length)%todasImagenes.length)}
              style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,.9)',border:'none',color:'#111614',borderRadius:'50%',width:36,height:36,cursor:'pointer',fontSize:'1.2rem',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 2px 8px rgba(0,0,0,.15)'}}>
              ‹
            </button>
            <button onClick={()=>setActiva(a=>(a+1)%todasImagenes.length)}
              style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'rgba(255,255,255,.9)',border:'none',color:'#111614',borderRadius:'50%',width:36,height:36,cursor:'pointer',fontSize:'1.2rem',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 2px 8px rgba(0,0,0,.15)'}}>
              ›
            </button>
            <div style={{position:'absolute',bottom:12,left:'50%',transform:'translateX(-50%)',display:'flex',gap:6}}>
              {todasImagenes.map((_,i)=>(
                <button key={i} onClick={()=>setActiva(i)}
                  style={{width:i===activa?20:8,height:8,borderRadius:100,background:i===activa?'#4db88a':'rgba(255,255,255,.6)',border:'none',cursor:'pointer',transition:'all .2s',padding:0}}/>
              ))}
            </div>
          </>
        )}
      </div>
      {/* Miniaturas */}
      {todasImagenes.length > 1 && (
        <div style={{display:'flex',gap:'.5rem',overflowX:'auto',paddingBottom:'.2rem'}}>
          {todasImagenes.map((img, i)=>(
            <button key={img.id||i} onClick={()=>setActiva(i)}
              style={{width:64,height:64,borderRadius:10,overflow:'hidden',flexShrink:0,border:i===activa?'2.5px solid #4db88a':'2.5px solid transparent',padding:0,cursor:'pointer',background:'#f3f8f5',transition:'border-color .2s'}}>
            <img src={img.url} alt={`Mini ${i+1}`} style={{width:'100%',height:'100%',objectFit:'contain',background:'#fff'}}/>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function RecursoDetalle() {
  const { id }       = useParams();
  const navigate     = useNavigate();
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();

  const [recurso,  setRecurso]  = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  const enCarrito = recurso ? estaEnCarrito(recurso.id) : false;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API_PAGA}?action=detail&id=${id}`)
      .then(r => r.json())
      .then(j => {
        if (j.success) setRecurso(j.data);
        else setError('Material no encontrado');
      })
      .catch(() => setError('Error de conexión'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'1rem',color:'#5a6a63'}}>
        <IconSpinner/><p>Cargando material…</p>
      </div>
      <style>{`@keyframes rd-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  if (error || !recurso) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{textAlign:'center'}}>
        <p style={{fontSize:'3rem',marginBottom:'1rem'}}>😕</p>
        <h2 style={{marginBottom:'.5rem'}}>Material no encontrado</h2>
        <button onClick={()=>navigate('/recursos')} style={{background:'#111614',color:'#82D8B3',border:'none',borderRadius:100,padding:'.75rem 1.5rem',fontFamily:'inherit',fontWeight:700,cursor:'pointer'}}>
          Volver a materiales
        </button>
      </div>
    </div>
  );

  const col      = colorMap[recurso.color] || colorMap.verde;
  const precio   = parseFloat(recurso.precio || 0);
  const pAntes   = recurso.precio_antes ? parseFloat(recurso.precio_antes) : null;
  const ahorro   = pAntes ? (pAntes - precio).toFixed(0) : null;
  const tags     = Array.isArray(recurso.tags) ? recurso.tags : [];

  return (
    <div style={{minHeight:'100vh',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif",color:'#111614'}}>
      <style>{`
        @keyframes rd-spin{to{transform:rotate(360deg)}}
        @keyframes rd-fadein{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
        .rd-page{animation:rd-fadein .4s ease}
        .rd-btn-primary{background:#111614;color:#82D8B3;border:none;border-radius:100px;padding:1rem 2rem;fontFamily:inherit;fontWeight:700;fontSize:1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:.5rem;width:100%;transition:all .2s;}
        .rd-btn-primary:hover{background:#1a2e26;transform:translateY(-1px)}
        .rd-btn-secondary{background:transparent;color:#111614;border:1.5px solid rgba(130,216,179,.4);border-radius:100px;padding:.9rem 2rem;fontFamily:inherit;fontWeight:700;fontSize:.9rem;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:.5rem;width:100%;transition:all .2s;}
        .rd-btn-secondary:hover{border-color:#4db88a;background:#edfaf4}
        .rd-tag{display:inline-flex;align-items:center;gap:.3rem;background:#edfaf4;color:#0f3525;border-radius:100px;padding:.3rem .75rem;font-size:.75rem;font-weight:600;}
      `}</style>

      {/* NAV */}
      <nav style={{background:'#fff',borderBottom:'1px solid rgba(130,216,179,.2)',padding:'.9rem 5%',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,zIndex:50}}>
        <button onClick={()=>navigate('/recursos')}
          style={{display:'flex',alignItems:'center',gap:'.4rem',background:'none',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:100,padding:'.45rem 1rem',fontFamily:'inherit',fontWeight:600,fontSize:'.85rem',color:'#5a6a63',cursor:'pointer'}}>
          <IconBack/> Volver a materiales
        </button>
        <Link to="/" style={{display:'flex',alignItems:'center',textDecoration:'none'}}>
          <svg height="40" viewBox="0 0 300 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="20" cy="28" rx="14" ry="12" fill="#82D8B3" opacity="0.7"/>
            <path d="M10 38 Q6 44 4 48 Q11 43 16 40Z" fill="#82D8B3" opacity="0.7"/>
            <ellipse cx="34" cy="22" rx="20" ry="17" fill="#82D8B3"/>
            <path d="M20 36 Q16 44 13 48 Q22 42 27 38Z" fill="#82D8B3"/>
            <circle cx="27" cy="22" r="2.2" fill="white"/>
            <circle cx="34" cy="22" r="2.2" fill="white"/>
            <circle cx="41" cy="22" r="2.2" fill="white"/>
            <text x="62" y="24" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="16" fill="#4db88a" letterSpacing="0.2">Centro Comunicar</text>
            <text x="64" y="38" fontFamily="'DM Sans', sans-serif" fontWeight="400" fontSize="10" fill="#888">Comunicar – Lenguaje, Aprendizaje y Habla</text>
          </svg>
        </Link>
        <button onClick={()=>navigate('/carrito')}
          style={{display:'flex',alignItems:'center',gap:'.4rem',background:'none',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:100,padding:'.45rem 1rem',fontFamily:'inherit',fontWeight:600,fontSize:'.85rem',color:'#5a6a63',cursor:'pointer'}}>
          <IconCart/> Carrito
        </button>
      </nav>

      {/* CONTENIDO */}
      <div className="rd-page" style={{maxWidth:1000,margin:'0 auto',padding:'2.5rem 5%',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'3rem',alignItems:'start'}}>

        {/* COLUMNA IZQUIERDA — Galería */}
        <div style={{position:'sticky',top:90}}>
          <Galeria
            imagenes={recurso.imagenes || []}
            imagenPortada={recurso.imagen_url}
            color={recurso.color}
          />

          {/* Badges de confianza */}
          <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap',marginTop:'1rem'}}>
            {[
              {icon:'📥', label:'Descarga inmediata'},
              {icon:'♾️', label:'Acceso de por vida'},
              {icon:'🖨️', label:'Listo para imprimir'},
            ].map(({icon,label})=>(
              <span key={label} style={{display:'flex',alignItems:'center',gap:'.3rem',background:'#fff',border:'1px solid rgba(130,216,179,.25)',borderRadius:100,padding:'.3rem .75rem',fontSize:'.72rem',fontWeight:600,color:'#5a6a63'}}>
                {icon} {label}
              </span>
            ))}
          </div>
        </div>

        {/* COLUMNA DERECHA — Detalle */}
        <div style={{display:'flex',flexDirection:'column',gap:'1.5rem'}}>

          {/* Categoría + tipo */}
          <div style={{display:'flex',gap:'.5rem',alignItems:'center',flexWrap:'wrap'}}>
            <span style={{background:col.bg,color:col.text,borderRadius:100,padding:'.3rem .85rem',fontSize:'.75rem',fontWeight:700,letterSpacing:'.04em'}}>
              {recurso.categoria?.toUpperCase()}
            </span>
            <span style={{display:'flex',alignItems:'center',gap:'.3rem',color:'#5a6a63',fontSize:'.8rem',fontWeight:600}}>
              {TIPO_ICON[recurso.tipo]} {TIPO_LABEL[recurso.tipo] || recurso.tipo}
            </span>
            {recurso.badge && (
              <span style={{background:'#111614',color:'#82D8B3',borderRadius:100,padding:'.3rem .75rem',fontSize:'.72rem',fontWeight:700}}>
                {recurso.badge}
              </span>
            )}
          </div>

          {/* Título */}
          <h1 style={{fontSize:'1.6rem',fontWeight:800,lineHeight:1.25,color:'#111614',margin:0}}>
            {recurso.titulo}
          </h1>

          {/* Rating */}
          {recurso.rating > 0 && (
            <div style={{display:'flex',alignItems:'center',gap:'.5rem'}}>
              <div style={{display:'flex',gap:2}}>
                {[1,2,3,4,5].map(n=><IconStar key={n} filled={n<=Math.round(recurso.rating)}/>)}
              </div>
              <span style={{fontWeight:700,color:'#111614'}}>{recurso.rating}</span>
              {recurso.ventas > 0 && <span style={{color:'#5a6a63',fontSize:'.85rem'}}>· {recurso.ventas} ventas</span>}
            </div>
          )}

          {/* Precio */}
          <div style={{display:'flex',alignItems:'center',gap:'.8rem'}}>
            <span style={{fontSize:'2rem',fontWeight:800,color:'#111614'}}>S/. {precio.toFixed(0)}</span>
            {pAntes && <s style={{fontSize:'1.1rem',color:'#9ca3af'}}>S/. {pAntes.toFixed(0)}</s>}
            {ahorro && (
              <span style={{background:'#d4f4e8',color:'#0f3525',borderRadius:100,padding:'.25rem .75rem',fontSize:'.78rem',fontWeight:700}}>
                Ahorras S/. {ahorro}
              </span>
            )}
          </div>

          {/* Descripción corta */}
          {recurso.descripcion && (
            <p style={{fontSize:'.95rem',lineHeight:1.7,color:'#5a6a63',margin:0}}>
              {recurso.descripcion}
            </p>
          )}

          {/* Descripción larga */}
          {recurso.descripcion_larga && (
            <div style={{background:'#fff',borderRadius:14,padding:'1.2rem',border:'1.5px solid rgba(130,216,179,.15)'}}>
              <p style={{fontSize:'.9rem',lineHeight:1.8,color:'#374151',margin:0,whiteSpace:'pre-line'}}>
                {recurso.descripcion_larga}
              </p>
            </div>
          )}

          {/* Detalles del material */}
          <div style={{background:'#fff',borderRadius:14,padding:'1.2rem',border:'1.5px solid rgba(130,216,179,.15)',display:'flex',flexDirection:'column',gap:'.6rem'}}>
            <p style={{fontSize:'.78rem',fontWeight:700,color:'#4db88a',textTransform:'uppercase',letterSpacing:'.1em',margin:0}}>
              Detalles del material
            </p>
            {[
              recurso.formato   && { label:'Formato',   value: recurso.formato },
              recurso.paginas   && { label:'Páginas',   value: `${recurso.paginas} páginas` },
              recurso.nivel     && { label:'Nivel',     value: recurso.nivel },
              recurso.categoria && { label:'Categoría', value: recurso.categoria },
            ].filter(Boolean).map(({label, value}) => (
              <div key={label} style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem',borderBottom:'1px solid #f3f8f5',paddingBottom:'.5rem'}}>
                <span style={{color:'#5a6a63'}}>{label}</span>
                <span style={{fontWeight:600,color:'#111614'}}>{value}</span>
              </div>
            ))}
          </div>

          {/* Qué incluye */}
          <div style={{display:'flex',flexDirection:'column',gap:'.5rem'}}>
            <p style={{fontSize:'.78rem',fontWeight:700,color:'#4db88a',textTransform:'uppercase',letterSpacing:'.1em',margin:0}}>
              ¿Qué incluye?
            </p>
            {[
              'Archivo PDF listo para descargar e imprimir',
              'Acceso inmediato tras validar el pago',
              'Acceso de por vida desde tu cuenta',
              'Soporte por WhatsApp',
            ].map(item => (
              <div key={item} style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.85rem',color:'#374151'}}>
                <IconCheck/> {item}
              </div>
            ))}
          </div>

          {/* Tags */}
          {tags.length > 0 && (
            <div style={{display:'flex',gap:'.4rem',flexWrap:'wrap'}}>
              {tags.map(t => (
                <span key={t} className="rd-tag"><IconTag/>{t}</span>
              ))}
            </div>
          )}

          {/* Botones CTA */}
          <div style={{display:'flex',flexDirection:'column',gap:'.7rem',paddingTop:'.5rem'}}>
            {enCarrito ? (
              <button className="rd-btn-primary" onClick={() => navigate('/carrito')}>
                <IconCart/> Ver en el carrito
              </button>
            ) : (
              <button className="rd-btn-primary" onClick={() => {
                if (!estaLogueado) { navigate('/login?redirect=/recursos/' + id); return; }
                agregarItem({
                  id:               recurso.id,
                  titulo:           recurso.titulo,
                  precio:           precio,
                  tipo:             recurso.tipo,
                  color:            recurso.color,
                  imagen:           recurso.imagen_url || null,
                  descripcion_larga: recurso.descripcion_larga || null,
                  imagenes:         recurso.imagenes || [],
                  digital:          true,
                });
                navigate('/carrito');
              }}>
                <IconCartPlus/> Agregar al carrito
              </button>
            )}
            <a
              href={`https://wa.me/51940686868?text=${encodeURIComponent('Hola, me interesa el material: ' + recurso.titulo)}`}
              target="_blank" rel="noopener noreferrer"
              style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'.5rem',background:'#25d366',color:'#fff',border:'none',borderRadius:100,padding:'.9rem 2rem',fontFamily:'inherit',fontWeight:700,fontSize:'.9rem',cursor:'pointer',textDecoration:'none',transition:'all .2s'}}
            >
              <IconWhatsapp/> Consultar por WhatsApp
            </a>
          </div>

          {/* Garantías */}
          <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap',paddingTop:'.5rem',borderTop:'1px solid rgba(130,216,179,.15)'}}>
            {[
              {icon:<IconShield/>, label:'Pago seguro'},
              {icon:<IconDownload/>, label:'Descarga inmediata'},
              {icon:<IconCheck/>, label:'Soporte incluido'},
            ].map(({icon,label})=>(
              <div key={label} style={{display:'flex',alignItems:'center',gap:'.3rem',fontSize:'.75rem',color:'#5a6a63',fontWeight:600}}>
                {icon} {label}
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* RESPONSIVE */}
      <style>{`
        @media(max-width:700px){
          .rd-page{grid-template-columns:1fr!important;gap:1.5rem!important}
          .rd-page > div:first-child{position:static!important}
        }
      `}</style>
    </div>
  );
}